// Utilitaires pour préserver les données du tutoriel lors de la déconnexion

const TUTORIAL_KEY_PREFIX = 'lcdf_tutorial_state';
const TUTORIAL_DELIVERY_KEY_PREFIX = 'lcdf_tutorial_delivery_read';

/**
 * Sauvegarde les données du tutoriel depuis le localStorage
 * @returns {Object} Objet contenant toutes les données du tutoriel
 */
export const saveTutorialData = () => {
  const tutorialData = {};
  
  try {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith(TUTORIAL_KEY_PREFIX) || key.startsWith(TUTORIAL_DELIVERY_KEY_PREFIX)) {
        tutorialData[key] = localStorage.getItem(key);
      }
    });
  } catch (error) {
    console.error('Erreur lors de la sauvegarde des données du tutoriel:', error);
  }
  
  return tutorialData;
};

/**
 * Restaure les données du tutoriel dans le localStorage
 * @param {Object} tutorialData - Données du tutoriel à restaurer
 */
export const restoreTutorialData = (tutorialData) => {
  try {
    Object.keys(tutorialData).forEach(key => {
      if (tutorialData[key]) {
        localStorage.setItem(key, tutorialData[key]);
      }
    });
  } catch (error) {
    console.error('Erreur lors de la restauration des données du tutoriel:', error);
  }
};

/**
 * Vide le localStorage tout en préservant les données du tutoriel
 */
export const clearLocalStorageExceptTutorial = () => {
  // Sauvegarder les données du tutoriel
  const tutorialData = saveTutorialData();
  
  // Vider le localStorage
  localStorage.clear();
  
  // Restaurer les données du tutoriel
  restoreTutorialData(tutorialData);
  
  console.log('localStorage vidé - Données du tutoriel et tutoriel déballage préservées');
};

/**
 * Vide complètement le localStorage (y compris le tutoriel)
 * Utilisé uniquement pour le debugging ou la réinitialisation complète
 */
export const clearAllLocalStorage = () => {
  localStorage.clear();
  console.log('localStorage complètement vidé (y compris le tutoriel)');
};

export default {
  saveTutorialData,
  restoreTutorialData,
  clearLocalStorageExceptTutorial,
  clearAllLocalStorage
};